export const getHost = () => {
  if (window.location.hostname === 'localhost') {
    return process.env.REACT_APP_PAYMENT_REDIRECT_BASE;
  }
  return window.location.protocol + '//' + window.location.hostname;
};

/**
 * Base URL for payment gateway redirects back into this frontend.
 *
 * Prefer `REACT_APP_PAYMENT_REDIRECT_BASE` when set (e.g. ngrok during local dev),
 * otherwise fall back to the current app origin.
 */
export const getPaymentRedirectBase = () => {
  const fromEnv = process.env.REACT_APP_PAYMENT_REDIRECT_BASE;
  if (fromEnv && typeof fromEnv === 'string') {
    return fromEnv.replace(/\/+$/, '');
  }
  return window.location.origin;
};
